import { render, staticRenderFns } from "./PortfolioDetail.vue?vue&type=template&id=4af83d26&scoped=true"
import script from "./PortfolioDetail.vue?vue&type=script&lang=js"
export * from "./PortfolioDetail.vue?vue&type=script&lang=js"
import style0 from "./PortfolioDetail.vue?vue&type=style&index=0&id=4af83d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af83d26",
  null
  
)

export default component.exports